// this gives height to the body for the quick navigation -> no overlapping on the page

export function quickNavigation() {
    const targetNode = document.getElementById(
        "quick-navigation",
    ) as HTMLElement;
    const body = document.querySelector<HTMLElement>(".footer .wrapper");

    if (targetNode && body) {
        new ResizeObserver(function () {
            body.style.marginBottom = `${targetNode.offsetHeight}px`;
        }).observe(targetNode);
    }
}
